import { Firebase } from '@linktivity/link-utils';
import { config as env } from '@triplabo/web/utils/env';

let webAuth: Firebase | undefined;

// constructing Firebase preloads the auth iframe from authDomain, which the
// mini program web-view refuses to open, so it is only created on first use
export const getWebAuth = () => {
  if (!webAuth) {
    webAuth = new Firebase({
      apiKey: env.firebaseApiKey,
      authDomain: env.firebaseAuthDomain
    });

    if (env.firebaseTenantId) {
      webAuth.setTenantId(env.firebaseTenantId);
    }
  }

  return webAuth;
};
